import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectKeyFieldErrorBypassMessages } from 'src/redux/slices/umibuilder/selectors'

import { Button, Divider } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import CancelIcon from '@material-ui/icons/Cancel'
import DescriptionIcon from '@material-ui/icons/Description'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import { AlertProps } from '@material-ui/lab'
import MuiAlert from '@material-ui/lab/Alert'

///// Hooks
const useStyles = makeStyles((theme) => ({
  root: {
    width: '80vw',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  actions: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    backgroundColor: '#000000' + 'cc',
  },
}))

///// Component
function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant='filled' {...props} />
}

///// Types
type KeyfieldsErrorBypassModalProps = {
  open: boolean
  handleClose(): void
  handleContinue(): void
}

///// Component
const KeyfieldsErrorBypassModal: React.FC<KeyfieldsErrorBypassModalProps> = ({
  open,
  handleClose,
  handleContinue,
}) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const errorSummary = useSelector(selectKeyFieldErrorBypassMessages)
  const acceptAndContinue = useCallback(() => {
    handleContinue()
    handleClose()
  }, [handleClose, handleContinue])

  return (
    <div className={classes.root}>
      <Dialog open={open} onClose={handleClose} BackdropProps={{ className: classes.backdrop }}>
        <Alert onClose={handleClose} severity='warning' color='info'>
          <Typography variant='h5' component='h3'>
            Keyfields errors
          </Typography>
          <Typography variant='body2'>
            The current keyfields-to-column assignment has errors which UBEM.io will try to fix. For
            more information about GIS data requirements, please open the help bar.
          </Typography>
          <Grid container spacing={1}>
            {errorSummary.map(({ automatedAction, summary }, i) => (
              <Grid item xs={12} key={`keyfields-warning-${i}`}>
                <Typography variant='overline' component='h5'>
                  {summary}
                </Typography>
                <Typography variant='caption'>{automatedAction}</Typography>
                <Divider />
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={2} className={classes.actions} justifyContent='center'>
            <Grid item>
              <Button
                size='small'
                startIcon={<CancelIcon />}
                variant='contained'
                color='primary'
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                size='small'
                endIcon={<NavigateNextIcon />}
                variant='contained'
                color='primary'
                onClick={acceptAndContinue}
              >
                Accept and Continue
              </Button>
            </Grid>
            <Grid item>
              <Button
                size='small'
                endIcon={<DescriptionIcon />}
                variant='contained'
                color='primary'
                onClick={handleClose}
              >
                Download Report
              </Button>
            </Grid>
          </Grid>
        </Alert>
      </Dialog>
    </div>
  )
}

export default KeyfieldsErrorBypassModal
